import { Component, inject } from '@angular/core';
import { VideoLayout, VideoLayoutService } from '../shared/video-layout.service';

@Component({
  selector: 'vb-lxp-layout-selector',
  templateUrl: './vb-lxp-layout-selector.component.html',
  styleUrl: './vb-lxp-layout-selector.component.css',
})
export class VbLxpLayoutSelectorComponent {
  public layoutService = inject(VideoLayoutService);
  protected readonly VideoLayout = VideoLayout;
}
